import { SERVICE_URL } from 'config';
import api from '../api';

const objectsData = {
  status: 'success',
  object: {
    id: '190500000',
    object_name: 'Tardiness Request Form',
    type: 'Card',
    table_id: '1575000',
    table_name: 'attendance_change_request',
    title: 'Tardiness Request Form',
    department: '',
    url_link: '',
    custom_template: 'default',
    foundation: 'No',
    controller_path: 'App\\Http\\Controllers\\HR\\HR\\TardinessRequestFormController',
    view_path: 'hr/hr/tardiness_request_form/tardiness_request_form',
    route_path: 'hr.php',
    route_content:
      "Route::group(array('prefix' => '/tardiness-request-form', 'namespace' => 'HR\\HR', 'object_id' => '190500000'), function () {\n    Route::get('/', array('as' => 'tardiness-request-form.index', 'middleware' => 'index', 'uses' => 'TardinessRequestFormController@index'));\n    Route::group(array('middleware' => 'ajax'), function () {\n        Route::get('/index-search', array('as' => 'tardiness-request-form.index-search', 'uses' => 'TardinessRequestFormController@indexSearch'));\n        Route::get('/index-card', array('as' => 'tardiness-request-form.index-card', 'uses' => 'TardinessRequestFormController@indexCard'));\n        Route::get('/refresh-card', array('as' => 'tardiness-request-form.refresh-card', 'uses' => 'TardinessRequestFormController@refreshCard'));\n        Route::get('/index-table', array('as' => 'tardiness-request-form.index-table', 'uses' => 'TardinessRequestFormController@indexTable'));\n        Route::get('/index-card-line', array('as' => 'tardiness-request-form.index-card-line', 'uses' => 'TardinessRequestFormController@indexCardLine'));\n        Route::get('/index-popup-line', array('as' => 'tardiness-request-form.index-popup-line', 'uses' => 'TardinessRequestFormController@indexPopupLine'));\n        Route::get('/new-record', array('as' => 'tardiness-request-form.new-record', 'uses' => 'TardinessRequestFormController@newRecord'));\n        Route::get('/first-record', array('as' => 'tardiness-request-form.first-record', 'uses' => 'TardinessRequestFormController@firstRecord'));\n        Route::get('/previous-record', array('as' => 'tardiness-request-form.previous-record', 'uses' => 'TardinessRequestFormController@previousRecord'));\n        Route::get('/next-record', array('as' => 'tardiness-request-form.next-record', 'uses' => 'TardinessRequestFormController@nextRecord'));\n        Route::get('/last-record', array('as' => 'tardiness-request-form.last-record', 'uses' => 'TardinessRequestFormController@lastRecord'));\n        Route::get('/get-save-to-excel', array('as' => 'tardiness-request-form.get-save-to-excel', 'uses' => 'TardinessRequestFormController@getSaveToExcel'));\n        Route::get('/get-upload-from-excel', array('as' => 'tardiness-request-form.get-upload-from-excel', 'uses' => 'TardinessRequestFormController@getUploadFromExcel'));\n        Route::post('/store-record', array('as' => 'tardiness-request-form.store-record', 'uses' => 'TardinessRequestFormController@storeRecord'));\n        Route::post('/update-record', array('as' => 'tardiness-request-form.update-record', 'uses' => 'TardinessRequestFormController@updateRecord'));\n        Route::post('/update-line-record', array('as' => 'tardiness-request-form.update-line-record', 'uses' => 'TardinessRequestFormController@updateLineRecord'));\n        Route::post('/delete-record', array('as' => 'tardiness-request-form.delete-record', 'uses' => 'TardinessRequestFormController@deleteRecord'));\n        Route::post('/store-line-record', array('as' => 'tardiness-request-form.store-line-record', 'uses' => 'TardinessRequestFormController@storeLineRecord'));\n        Route::post('/insert-line-record', array('as' => 'tardiness-request-form.insert-line-record', 'uses' => 'TardinessRequestFormController@insertLineRecord'));\n        Route::post('/duplicate-line-record', array('as' => 'tardiness-request-form.duplicate-line-record', 'uses' => 'TardinessRequestFormController@duplicateLineRecord'));\n        Route::post('/delete-line-record', array('as' => 'tardiness-request-form.delete-line-record', 'uses' => 'TardinessRequestFormController@deleteLineRecord'));\n        Route::post('/delete-all-line-record', array('as' => 'tardiness-request-form.delete-all-line-record', 'uses' => 'TardinessRequestFormController@deleteAllLineRecord'));        \n        Route::post('/mark-record', array('as' => 'tardiness-request-form.mark-record', 'uses' => 'TardinessRequestFormController@markRecord'));\n        Route::post('/mark-all-record', array('as' => 'tardiness-request-form.mark-all-record', 'uses' => 'TardinessRequestFormController@markAllRecord'));\n        Route::post('/save-download-to-excel', array('as' => 'tardiness-request-form.save-download-to-excel', 'uses' => 'TardinessRequestFormController@saveDownloadToExcel'));\n        Route::post('/save-upload-from-excel-temp', array('as' => 'tardiness-request-form.save-upload-from-excel-temp', 'uses' => 'TardinessRequestFormController@saveUploadFromExcelTemp'));\n        Route::post('/save-upload-from-excel', array('as' => 'tardiness-request-form.save-upload-from-excel', 'uses' => 'TardinessRequestFormController@saveUploadFromExcel'));\n        Route::get('/add-remark', array('as' => 'tardiness-request-form.add-remark', 'uses' => 'TardinessRequestFormController@addRemark'));\n        Route::post('/save-remark', array('as' => 'tardiness-request-form.save-remark', 'uses' => 'TardinessRequestFormController@saveRemark'));        \n        Route::post('/copy-record', array('as' => 'tardiness-request-form.copy-record', 'uses' => 'TardinessRequestFormController@copyRecord'));\n        Route::get('/new-table-record', array('as' => 'tardiness-request-form.new-table-record', 'uses' => 'TardinessRequestFormController@newTableRecord'));\n        Route::post('/update-table-record', array('as' => 'tardiness-request-form.update-table-record', 'uses' => 'TardinessRequestFormController@updateTableRecord'));\n        Route::post('/delete-table-record', array('as' => 'tardiness-request-form.delete-table-record', 'uses' => 'TardinessRequestFormController@deleteTableRecord'));\n        Route::post('/delete-table-all-record', array('as' => 'tardiness-request-form.delete-table-all-record', 'uses' => 'TardinessRequestFormController@deleteTableAllRecord'));\n        Route::get('/print-report', array('as' => 'tardiness-request-form.print-report', 'uses' => 'TardinessRequestFormController@printReport'));   \n\n        // ADDITIONAL CUSTOM URL\n    });\n});\n",
    menu_path: 'Human Capital/Attendance/Tardiness Request Form',
    menu_url: '/tardiness-request-form',
    editable: 'Yes',
    insertable: 'Yes',
    deletable: 'Yes',
    printable: 'Yes',
    paginatable: 'Yes',
    auto_preview: 'No',
    show_as_table: 'Yes',
    sortable: 'Yes',
    status: 'Actived',
    is_deleted: '0',
    created_by: '013518919',
    created_at: '2023-11-13 16:31:47',
    updated_by: '013518919',
    updated_at: '2023-11-13 16:34:07',
    deleted_by: '013518919',
    deleted_at: '2023-11-13 16:34:07',
    object_groups: [
      {
        id: '14049',
        object_group_id: '190500000',
        object_id: '190500000',
        username: 'JACKIE-MOBILE-POS',
        description: 'Table',
        table_name: 'attendance_change_request',
        freeze_column_no: '0',
        foreign_key_name: '',
        primary_key_name: '',
        model_path: 'App\\Models\\HR\\HR\\AttendanceChangeRequest',
        page_name: '',
        type: 'Table',
        editable: 'No',
        insertable: 'No',
        deletable: 'No',
        copiable: 'No',
        hidden: 'No',
        filter: 'Yes',
        parameter: null,
        group_range: '1',
        advance_url: null,
        stage: 'in',
        modal_size: 'modal-md',
        editable_field_on_released: '',
        editable_field_on_pending: '',
        editable_field_on_booked: '',
        editable_field_on_line_booked: '',
        sort_by: 'asc',
        sort_field: '',
        owner_record: 'No',
        index: '0',
        filters: null,
        is_deleted: '0',
        created_by: 'JACKIE-MOBILE-POS',
        created_at: '2023-11-18 12:40:21',
        updated_by: null,
        updated_at: '2023-11-18 12:40:21',
        deleted_by: null,
        deleted_at: null,
      },
      {
        id: '14050',
        object_group_id: '190501000',
        object_id: '190500000',
        username: 'JACKIE-MOBILE-POS',
        description: 'Employee Information',
        table_name: 'attendance_change_request',
        freeze_column_no: '0',
        foreign_key_name: '',
        primary_key_name: '',
        model_path: 'App\\Models\\HR\\HR\\AttendanceChangeRequest',
        page_name: '',
        type: 'Card',
        editable: 'Yes',
        insertable: 'Yes',
        deletable: 'Yes',
        copiable: 'No',
        hidden: 'No',
        filter: 'Yes',
        parameter: null,
        group_range: '2',
        advance_url: null,
        stage: 'in',
        modal_size: 'modal-md',
        editable_field_on_released: '',
        editable_field_on_pending: '',
        editable_field_on_booked: '',
        editable_field_on_line_booked: '',
        sort_by: 'asc',
        sort_field: '',
        owner_record: 'No',
        index: '0',
        filters: null,
        is_deleted: '0',
        created_by: 'JACKIE-MOBILE-POS',
        created_at: '2023-11-18 12:40:21',
        updated_by: null,
        updated_at: '2023-11-18 12:40:21',
        deleted_by: null,
        deleted_at: null,
      },
      {
        id: '14051',
        object_group_id: '190503000',
        object_id: '190500000',
        username: 'JACKIE-MOBILE-POS',
        description: 'Missing Attendance Reason',
        table_name: 'attendance_change_request',
        freeze_column_no: '0',
        foreign_key_name: '',
        primary_key_name: '',
        model_path: 'App\\Models\\HR\\HR\\AttendanceChangeRequest',
        page_name: '',
        type: 'Card',
        editable: 'Yes',
        insertable: 'Yes',
        deletable: 'Yes',
        copiable: 'No',
        hidden: 'No',
        filter: 'No',
        parameter: null,
        group_range: '3',
        advance_url: null,
        stage: 'in',
        modal_size: 'modal-full',
        editable_field_on_released: '',
        editable_field_on_pending: '',
        editable_field_on_booked: '',
        editable_field_on_line_booked: '',
        sort_by: 'asc',
        sort_field: '',
        owner_record: 'No',
        index: '0',
        filters: null,
        is_deleted: '0',
        created_by: 'JACKIE-MOBILE-POS',
        created_at: '2023-11-18 12:40:21',
        updated_by: null,
        updated_at: '2023-11-18 12:40:21',
        deleted_by: null,
        deleted_at: null,
      },
      {
        id: '14052',
        object_group_id: '190504000',
        object_id: '190500000',
        username: 'JACKIE-MOBILE-POS',
        description: 'Request Change to Update Timesheets',
        table_name: 'attendance_change_request',
        freeze_column_no: '0',
        foreign_key_name: '',
        primary_key_name: '',
        model_path: 'App\\Models\\HR\\HR\\AttendanceChangeRequest',
        page_name: '',
        type: 'Card',
        editable: 'Yes',
        insertable: 'Yes',
        deletable: 'Yes',
        copiable: 'No',
        hidden: 'No',
        filter: 'No',
        parameter: null,
        group_range: '4',
        advance_url: null,
        stage: 'in',
        modal_size: 'modal-full',
        editable_field_on_released: '',
        editable_field_on_pending: '',
        editable_field_on_booked: '',
        editable_field_on_line_booked: '',
        sort_by: 'asc',
        sort_field: '',
        owner_record: 'No',
        index: '0',
        filters: null,
        is_deleted: '0',
        created_by: 'JACKIE-MOBILE-POS',
        created_at: '2023-11-18 12:40:21',
        updated_by: null,
        updated_at: '2023-11-18 12:40:21',
        deleted_by: null,
        deleted_at: null,
      },
    ],
  },
  record: {
    id: 1,
    document_type: 'Tardiness Request Form',
    document_no: 'TRF000006',
    employee_no: 'HMC-0001',
    name: 'លឹម ស៊ីណា',
    name_2: 'Loem Sina',
    gender: 'Male',
    address: '',
    address_2: '',
    post_code: '',
    village: '',
    commune: '',
    district: '',
    province: '',
    phone_no: '+85599529399',
    phone_no_2: '',
    email: null,
    division_code: 'HMC BROILER',
    department_code: 'PRODUCTION',
    project_code: '',
    purchaser_code: '',
    position_code: '',
    line_code: '',
    team_code: 'ក្រុមថ្លឹងសាច់',
    store_code: '',
    category_code: '',
    career_code: '',
    basic_salary: '1,000,000.000000000000000000',
    basic_salary_option: 'Month',
    leave_code: '',
    grade_code: '',
    description: '',
    payroll_posting_group_code: 'DEFAULT',
    payroll_policy_code: 'HMC-WORKER',
    document_date: '14-Nov-2023',
    starting_date: '14-Nov-2023',
    ending_date: '14-Nov-2023',
    no_of_day: '1',
    no_series_code: '',
    workflow_request_code: '',
    currency_code: 'KHR',
    currency_factor: '1',
    khr_currency_factor: '4100.000000000000000000',
    thai_currency_factor: '30.000000000000000000',
    vn_currency_factor: '23185.000000000000000000',
    cn_currency_factor: '6.99',
    requester: '013518919',
    entry_type: 'Manual',
    attendance_missing_type: 'Forgot to swipte in or out',
    attendance_missing_remark: null,
    worksheet_code: 'R1',
    to_worksheet_code: '',
    picture: null,
    thumbnail: null,
    attendance_mission_period: 'Morning (IN)',
    mi: 'No',
    mo: 'No',
    ai: 'No',
    ao: 'No',
    ei: 'No',
    eo: 'No',
    starting_time: '06:00:00',
    break_starting_time: '12:00:00',
    break_ending_time: '13:00:00',
    ending_time: '16:00:00',
    is_overnight: 'No',
    is_dayoff: 'No',
    no_of_break_hour: '1.00',
    is_scan_on_break: 'No',
    starting_datetime: '14-Nov-2023 06:00:00',
    ending_datetime: '14-Nov-2023 16:00:00',
    break_starting_datetime: '14-Nov-2023 12:00:00',
    break_ending_datetime: '14-Nov-2023 13:00:00',
    request_change_action: '',
    actual_swipe_time: '',
    status: 'Released',
    to_starting_time: '08:00:00',
    to_break_starting_time: '12:00:00',
    to_break_ending_time: '13:00:00',
    to_ending_time: '17:00:00',
    to_is_overnight: 'No',
    to_is_dayoff: 'No',
    to_no_of_break_hour: '',
    to_is_scan_on_break: 'No',
    to_starting_datetime: '',
    to_ending_datetime: '',
    to_break_starting_datetime: '',
    to_break_ending_datetime: '',
    is_deleted: '0',
    created_by: '',
    created_at: '',
    updated_by: '',
    updated_at: '',
    deleted_by: '',
    deleted_at: '',
  },
  unid: null,
  msg: 'The request is successfully responsed!',
};
api.onGet(`${SERVICE_URL}/objects`).reply(200, objectsData);
